import React from "react";
import { useIntl } from "react-intl";
import { useWatch } from "react-hook-form";

import InputField from "components/atoms/InputField/InputField";

interface WeightFieldProps {
  isRequired: boolean;
  getRequestFormValues: any;
}

function WeightField({ isRequired, getRequestFormValues }: WeightFieldProps) {
  const intl = useIntl();
  const localWeightUnit = useWatch({ name: "w_unit" });
  const effectiveWeightUnit = localWeightUnit || getRequestFormValues(`packing.global_configuration.w_unit`);

  return (
    <div className="flex-row packing-list-add-item-input-large">
      <InputField
        label={
          effectiveWeightUnit === "total_lbs" || effectiveWeightUnit === "total_kg"
            ? "Total weight"
            : intl.formatMessage({
                id: "new-request.packing-list.pieceWeight",
                defaultMessage: "Piece weight",
              })
        }
        type="textinput"
        placeholder={intl.formatMessage({
          id: "new-request.packing-list.pieceWeight",
          defaultMessage: "Piece weight",
        })}
        field_id="weight_piece"
        validations={{
          validate: {
            onlyNumber: (v: any) => !isNaN(v) || "Please enter a valid number",
          },
          setValueAs: (v: string) => (!v ? null : v),
          shouldUnregister: true,
        }}
        required={isRequired}
      />
    </div>
  );
}

export default WeightField;
